import { NgModule } from '@angular/core';
import { Routes, RouterModule,ExtraOptions } from '@angular/router';
import { PagenotfoundComponent } from '../pagenotfound/pagenotfound.component';
export const routes: Routes = [
  {
    path: 'signon',
    loadChildren: () => import('../signon/signon.module').then(m => m.SignonModule)
  },
  {
    path: 'supported-browsers',
    loadChildren: () => import('../browsernotsupported/browsernotsupported.module').then(m => m.BrowsernotsupportedModule)
  },
  {
    path: 'ssologin',
    loadChildren: () => import('../ssologin/ssologin.module').then(m => m.SsologinModule)
  },
  {
    path: 'tyRewardsSignon',
    loadChildren: () => import('../tyrewards/tyrewards.module').then(m => m.TyRewardsModule)
  },
  {
    path: '**',
    component: PagenotfoundComponent
  }

];

@NgModule({
  imports: [ RouterModule.forRoot(routes, { initialNavigation: 'enabledNonBlocking' } )],
  exports: [RouterModule]
})
export class CoreRoutingModule { }